
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/simpleperf-register",
      function () {
        return require("private-next-pages/simpleperf-register.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/simpleperf-register"])
      });
    }
  